import {
  LOGIN_AUTH_ERROR, LOGIN_ERROR, LOGIN_REQUEST, LOGIN_SUCCESS, LOGOUT,
} from './types';

const initialState = {
  authError: null,
  data     : {},
  error    : null,
  loading  : false,
  requested: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LOGIN_AUTH_ERROR:
      return {
        ...state,
        authError: action.error,
        loading  : false,
        requested: true,
      };
    case LOGIN_ERROR:
      return {
        ...state,
        error    : action.error,
        loading  : false,
        requested: true,
      };
    case LOGIN_REQUEST:
      return {
        ...state,
        error    : null,
        loading  : true,
        requested: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        data     : action.data,
        loading  : false,
        requested: true,
      };
    case LOGOUT:
      return { ...initialState, requested: true };
    default:
      return state;
  }
}
